/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.searchPostsSkeleton'

export { $nsid }

/** Backend Posts search, returns only skeleton */
const main = l.query(
  $nsid,
  l.params({
    q: l.string(),
    sort: l.optional(
      l.withDefault(l.string<{ knownValues: ['top', 'latest'] }>(), 'latest'),
    ),
    since: l.optional(l.string()),
    until: l.optional(l.string()),
    mentions: l.optional(l.string({ format: 'at-identifier' })),
    author: l.optional(l.string({ format: 'at-identifier' })),
    lang: l.optional(l.string({ format: 'language' })),
    domain: l.optional(l.string()),
    url: l.optional(l.string({ format: 'uri' })),
    tag: l.optional(l.array(l.string({ maxLength: 640, maxGraphemes: 64 }))),
    viewer: l.optional(l.string({ format: 'did' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 25),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    hitsTotal: l.optional(l.integer()),
    posts: l.array(
      l.ref<UnspeccedDefs.SkeletonSearchPost>(
        (() => UnspeccedDefs.skeletonSearchPost) as any,
      ),
    ),
  }),
  ['BadQueryString'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
